/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListTrackableAssetsForFacilitiesBagScanQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type ListTrackableAssetsForFacilitiesBagScanQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, shouldConfirmMaterial: boolean, scannableCode?: string | null } | null> | null };

export type FacilityBagScanMutationVariables = Types.Exact<{
  input: Types.FacilityBagScanInput;
}>;


export type FacilityBagScanMutation = { __typename?: 'Mutation', facilityBagScan?: { __typename?: 'ScanEvent', id: string } | null };


export const ListTrackableAssetsForFacilitiesBagScanDocument = gql`
    query ListTrackableAssetsForFacilitiesBagScan($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    intendedMaterial
    status
    shouldConfirmMaterial
    scannableCode
  }
}
    `;

/**
 * __useListTrackableAssetsForFacilitiesBagScanQuery__
 *
 * To run a query within a React component, call `useListTrackableAssetsForFacilitiesBagScanQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTrackableAssetsForFacilitiesBagScanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTrackableAssetsForFacilitiesBagScanQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListTrackableAssetsForFacilitiesBagScanQuery(baseOptions?: Apollo.QueryHookOptions<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>(ListTrackableAssetsForFacilitiesBagScanDocument, options);
      }
export function useListTrackableAssetsForFacilitiesBagScanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>(ListTrackableAssetsForFacilitiesBagScanDocument, options);
        }
export function useListTrackableAssetsForFacilitiesBagScanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>(ListTrackableAssetsForFacilitiesBagScanDocument, options);
        }
export type ListTrackableAssetsForFacilitiesBagScanQueryHookResult = ReturnType<typeof useListTrackableAssetsForFacilitiesBagScanQuery>;
export type ListTrackableAssetsForFacilitiesBagScanLazyQueryHookResult = ReturnType<typeof useListTrackableAssetsForFacilitiesBagScanLazyQuery>;
export type ListTrackableAssetsForFacilitiesBagScanSuspenseQueryHookResult = ReturnType<typeof useListTrackableAssetsForFacilitiesBagScanSuspenseQuery>;
export type ListTrackableAssetsForFacilitiesBagScanQueryResult = Apollo.QueryResult<ListTrackableAssetsForFacilitiesBagScanQuery, ListTrackableAssetsForFacilitiesBagScanQueryVariables>;
export const FacilityBagScanDocument = gql`
    mutation FacilityBagScan($input: FacilityBagScanInput!) {
  facilityBagScan(input: $input) {
    id
  }
}
    `;
export type FacilityBagScanMutationFn = Apollo.MutationFunction<FacilityBagScanMutation, FacilityBagScanMutationVariables>;

/**
 * __useFacilityBagScanMutation__
 *
 * To run a mutation, you first call `useFacilityBagScanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacilityBagScanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facilityBagScanMutation, { data, loading, error }] = useFacilityBagScanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFacilityBagScanMutation(baseOptions?: Apollo.MutationHookOptions<FacilityBagScanMutation, FacilityBagScanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FacilityBagScanMutation, FacilityBagScanMutationVariables>(FacilityBagScanDocument, options);
      }
export type FacilityBagScanMutationHookResult = ReturnType<typeof useFacilityBagScanMutation>;
export type FacilityBagScanMutationResult = Apollo.MutationResult<FacilityBagScanMutation>;
export type FacilityBagScanMutationOptions = Apollo.BaseMutationOptions<FacilityBagScanMutation, FacilityBagScanMutationVariables>;